import { Typography } from "antd";

export const ConfirmOtpModalDescription = ({
  description,
  descriptionClassName,
}: {
  description?: React.ReactNode | string;
  descriptionClassName?: string | undefined;
}) => {
  return typeof description === "string" ? (
    <Typography.Text className={`${descriptionClassName || "margin-bottom-lg"}`}>{description}</Typography.Text>
  ) : (
    description
  );
};
